import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Spinner } from 'react-bootstrap'
import FullLogo from '../assets/logos/full-logo.png'
import CirclesBg from '../assets/svgs/not-found-circles.svg'
import { FooterContent } from './styled'
import {
  PageWrapper,
  BgCircles,
  ContentArea,
  SearchCircle,
  PageTitle,
  PageDescription,
} from './styled'
import BaseButton from './buttons/BaseButton'
import theme from '../constants/theme'
import SuccessIcon from '../assets/svgs/SuccessIcon'
import WarningIcon from '../assets/svgs/WarningIcon'
import ErrorIcon from '../assets/svgs/ErrorIcon'
import NotFoundIcon from '../assets/svgs/NotFoundIcon'

const TYPE_CONFIG = {
  success: {
    color: theme.success,
    titleKey: 'notification.success',
    icon: <SuccessIcon />,
  },
  warning: {
    color: theme.brandColorOrange,
    titleKey: 'notification.warning',
    icon: <WarningIcon />,
  },
  error: {
    color: theme.danger,
    titleKey: 'notification.error',
    icon: <ErrorIcon />,
  },
  notFound: {
    color: theme.talentinoSpecialBlue,
    titleKey: 'notification.notFound',
    icon: <NotFoundIcon />,
  },
}

export default function NotificationMessagePage({
  messageType,
  headerMessage,
  message,
  rescheduleInterview,
  rescheduleEnabled,
  isFinished,
  isExpired,
}) {
  const { t } = useTranslation()

  const config = TYPE_CONFIG[messageType] || TYPE_CONFIG.error
  const title = headerMessage || t(config.titleKey)

  return (
    <PageWrapper>
      <div className="p-3 ps-4">
        <img height="auto" width="130" src={FullLogo} alt="Valentino" />
      </div>

      <BgCircles>
        <img src={CirclesBg} alt="" aria-hidden="true" className="w-100" />
      </BgCircles>

      <ContentArea>
        {messageType === 'loading' ? (
          <>
            <Spinner
              animation="border"
              variant="secondary"
              style={{ height: '4rem', width: '4rem', marginBottom: '1.5rem' }}
            />
            <PageTitle>{title || t('pages.loading')}</PageTitle>
            {message && <PageDescription>{message}</PageDescription>}
          </>
        ) : (
          <>
            <SearchCircle
              style={{
                marginBottom: '1.5rem',
                borderColor: `${config.color}30`,
              }}
            >
              {config.icon}
            </SearchCircle>

            <PageTitle>{title}</PageTitle>

            {message && <PageDescription>{message}</PageDescription>}

            {rescheduleEnabled && !isFinished && isExpired && (
              <BaseButton
                className="mt-4"
                style={{ width: 'min(220px, 100%)' }}
                backgroundcolor={theme.brandColorOrange}
                hoverbackgroundcolor={theme.brandColorOrange}
                onClick={rescheduleInterview}
              >
                {t('interview.rescheduleInterview')}
              </BaseButton>
            )}
          </>
        )}
      </ContentArea>

      <FooterContent className="fixed-bottom text-center text-gray-100 py-2 border-t border-gray-200">
        {t('footer.TalentinoAI')}© {new Date().getFullYear()}
        {t('footer.allRightsReserved')}
      </FooterContent>
    </PageWrapper>
  )
}

NotificationMessagePage.propTypes = {
  messageType: PropTypes.string,
  headerMessage: PropTypes.string,
  message: PropTypes.string,
  rescheduleInterview: PropTypes.func,
  rescheduleEnabled: PropTypes.bool,
  isFinished: PropTypes.bool,
  isExpired: PropTypes.bool,
}

NotificationMessagePage.defaultProps = {
  messageType: 'error',
  headerMessage: '',
  message: '',
  rescheduleInterview: () => {},
  rescheduleEnabled: false,
  isFinished: false,
  isExpired: false,
}
